/* eslint-disable prefer-template */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import DocumentationDropdown from "shared-components/lib/documentation/documentation_dropdown";
import DocumentationLink from "shared-components/lib/documentation/documentation_link";
import { useSelector } from "react-redux";
import { getDocumentation, logEvent } from "../../../utils/api/api";
import t from "../../../utils/translation/translator";
import useCheckMobileScreen from "../../../utils/useCheckMobileScreen";
import { selectEventsData } from "../../../store/slices/common";
import { getCurrentConfiguration } from "../../../utils/api/common";
import {
  buildFileDownloadDataLayerEvent,
  logDataLayerEvent
} from "../../../utils/dataLayerAnalytics/dataLayerAnalytics";

const Documentation = ({ referenceIds }) => {
  const [documentation, setDocumentation] = useState({
    CAD: [],
    "Instruction sheet": [],
    "User guide": [],
    Certificate: [],
    Catalog: []
  });
  const isMobile = useCheckMobileScreen();
  const documentationLinks = [];
  const eventsData = useSelector(selectEventsData);
  const configuration = getCurrentConfiguration();
  // Get Products Documentation
  const {
    refetch: execGetProductsDocumentation,
    isFetching,
    isLoading
  } = useQuery(
    "GET PRODUCTS Documenration : it's a Post method",
    async () => {
      try {
        const fetchedDocumentations = await getDocumentation(referenceIds);
        // console.log("fetchedDocumentations", fetchedDocumentations);
        setDocumentation(fetchedDocumentations?.documentTypes);
        return fetchedDocumentations;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  // Get right documentation format for shared component
  const sum = (list) => list.reduce((a, c) => a + c, 0);

  function groupMapper(groupName, group) {
    const sizeValue = Math.round(sum(group.map((g) => g.size * 0.000001)));
    const documentGroup = new Map();
    documentGroup.set("name", groupName);
    documentGroup.set("group", group);
    if (sizeValue > 0) {
      documentGroup.set("fileSize", `${sizeValue} MB`);
    }
    return documentGroup;
  }

  // Get documentation href link
  const reduceDocumentsList = (documents) => Object.values(documents).reduce((a, c) => [...a, ...c], []);

  const composeDownloadParams = (documents) => {
    let result = null;
    try {
      const parameters = [];
      const documentList = !documents.length ? reduceDocumentsList(documents) : documents;

      const addType = (array, paramName) => {
        const str = array.filter((v) => v).join(",");
        if (str) {
          parameters.push(`${paramName}=${str}`);
        }
      };

      addType(
        documentList.map((d) => d.documentReference),
        "p_Doc_Ref"
      );
      addType(
        documentList.filter((d) => d.documentType === "Product Data Sheet").map((d) => d.fileName),
        "p_File_Name"
      );

      result = parameters.join("&");
    } catch (error) {
      console.log(error);
    }
    return result;
  };

  const downloadDocumentation = (title, document) => {
    const documentName = `Documentation (${title})`;
    const params = composeDownloadParams(document);
    const archiveName = `${documentName} - ${configuration?.configData?.configName}.zip`;
    return `https://download.schneider-electric.com/files?p_Archive_Name=${archiveName}&${params}&p_Scope_Independant=false`;
  };

  const logDownloadEvent = (documentName, extension) => {
    logEvent(eventsData.locale, eventsData.types.download, documentName, configuration?.configId);
    logDataLayerEvent(buildFileDownloadDataLayerEvent(documentName, extension));
  };

  // Create documentation links
  function createDocumentationLink(documentName, documentationKey) {
    return (
      <DocumentationLink
        key={documentName}
        name={t("msizer.ui.documentation." + documentName.toLowerCase().replace(/ /g, "_"))}
        loading={isFetching || isLoading}
        onDownload={(extension) => logDownloadEvent(documentName, extension)}
        documentGroup={documentationKey}
        getLabel={(key) => t(`msizer.ui.${key}`)}
        documentUrl={downloadDocumentation(documentName, documentation[documentName])}
      />
    );
  }

  // eslint-disable-next-line array-callback-return
  Object.keys(documentation).map((documentationKey) => {
    documentationLinks.push(
      createDocumentationLink(documentationKey, groupMapper(documentationKey, documentation[documentationKey]))
    );
  });

  useEffect(() => {
    execGetProductsDocumentation();
  }, []);

  console.log("documentationLink", documentationLinks);

  const [numberOfDocumentationFiles, setNumberOfDocumentationFile] = useState(0);

  useEffect(() => {
    // Filter documentationLinks to include only those with a non-empty group array
    const nonEmptyGroups = documentationLinks.filter((link) => {
      const documentGroup = link.props.documentGroup;
      const groupArray = documentGroup.get("group");
      return groupArray && groupArray.length > 0;
    });

    // Set the count of non-empty group arrays as the number of documentation files
    setNumberOfDocumentationFile(nonEmptyGroups.length);
  }, [documentationLinks]);

  return (
    <>
      <DocumentationDropdown
        title={t("msizer.ui.documentation") + " (" + numberOfDocumentationFiles + ")"}
        defaultOpenStatus={!isMobile}
        // eslint-disable-next-line react/no-children-prop
        children={documentationLinks}
      />
    </>
  );
};

Documentation.propTypes = {
  referenceIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Documentation;
